export enum NumberComparators {
  Equals = '=',
  MoreThan = '>',
  lessThan = '<',
  moreOrEqualThan = '>=',
  lessOrEqualThan = '<='
}